import { SETTINGS_BY_CARD_TYPE } from 'cards/constants/CardTypes';

// eslint-disable-next-line import/prefer-default-export
export const getCardSettings = cardType => {
  if (!cardType) return {};
  return SETTINGS_BY_CARD_TYPE[cardType] || {};
};



// WEBPACK FOOTER //
// ./src/cards/util/cardSettingsUtils.js